import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import {
  CurrentProductService,
  ProductImagesComponent,
  MediaComponent,
  CarouselComponent,
} from '@spartacus/storefront';
import { KnBrCommonPopUpComponent } from 'src/app/kn-br-customer360/kn-br-common-pop-up/kn-br-common-pop-up.component';
import { AsyncPipe, LowerCasePipe } from '@angular/common';
import { ProductSwitchService } from 'src/app/services/kn-br-product-switch.service';
import { I18nModule } from '@spartacus/core';

@Component({
  selector: 'kn-br-product-images',
  templateUrl: './kn-br-product-images.component.html',
  styleUrls: ['./kn-br-product-images.component.scss'],
  imports: [MediaComponent, CarouselComponent, AsyncPipe, I18nModule,LowerCasePipe],
})
export class KnBrProductImagesComponent extends ProductImagesComponent implements OnInit {
  constructor(
    private service: CurrentProductService,
    protected modalService: NgbModal,
    private productSwitch: ProductSwitchService,
    private cdr: ChangeDetectorRef
  ) {
    super(service);
  }
  modalRef: any;
  productName;
  variantProductData;

  customImagesMode = true;
  customMain: any = null;
  customThumbs: any[] = [];
  ngOnInit(): void {
    this.service.getProduct().subscribe((res) => (this.productName = res.name));
    this.productSwitch.productVariantCode$.subscribe((variantProductResp) => {
      if (variantProductResp) {
        this.variantProductData = variantProductResp;
        this.loadCustomImages(variantProductResp);
      } else {
        this.variantProductData = null;
        this.customImagesMode = false;
        this.cdr.markForCheck();
      }
    });
  }

  private loadCustomImages(variantProductResp) {
    this.customMain = variantProductResp?.images?.PRIMARY;
    this.customThumbs = variantProductResp?.images?.GALLERY || [];
    this.productName = variantProductResp?.name;
    if(this.customMain) {
      this.customImagesMode = true;
    }
    this.cdr.detectChanges();
  }

  enlargeImg(img) {
    let modalInstance: any;
    this.modalRef = this.modalService.open(KnBrCommonPopUpComponent, { centered: true, size: 'xl' });
    modalInstance = this.modalRef.componentInstance;
    modalInstance.image = img;
    modalInstance.header = this.productName;
  }
}
